import type { DbManagerKeyspace } from "../../../api/dbManager.service.js";
import { CUSTOM_RELEASE_DISABLED_TOOLTIP, isCustomRelease } from "./releaseDefinitionUtils.js";

export type MakeActiveButtonState = { disabled: boolean; title?: string; describedById?: string };

export type SearchIndexDescription =
  | { kind: "unknown" }
  | { kind: "ready"; summary: string }
  | { kind: "not-ready"; summary: string; reasons: string[] };

export function formatIndexedPercent(percentIndexed: number): string {
  return `${Math.floor(percentIndexed * 100)}%`;
}

export function formatFailures(count: number): string {
  return `${count.toLocaleString()} ${count === 1 ? "failure" : "failures"}`;
}

export function describeSearchIndex(entry: DbManagerKeyspace): SearchIndexDescription | null {
  if (entry.family !== "core" || entry.status === "empty" || entry.status === "running") {
    return null;
  }
  const index = entry.searchIndex;
  if (!index) return { kind: "unknown" };
  const summary = `${index.numDocs.toLocaleString()} docs, ${formatIndexedPercent(
    index.percentIndexed,
  )} indexed, ${formatFailures(index.hashIndexingFailures)}`;
  if (index.ready) return { kind: "ready", summary };
  return { kind: "not-ready", summary, reasons: index.reasons };
}

export function searchIndexReasonsId(entry: DbManagerKeyspace): string {
  return `search-index-reasons-${entry.family}-${entry.keyspace}`;
}

export function makeActiveButtonState(entry: DbManagerKeyspace): MakeActiveButtonState {
  if (isCustomRelease(entry.releaseDefinition)) {
    return { disabled: true, title: CUSTOM_RELEASE_DISABLED_TOOLTIP };
  }
  const description = describeSearchIndex(entry);
  if (description?.kind !== "not-ready") return { disabled: false };
  const reasons = description.reasons.length > 0 ? `: ${description.reasons.join("; ")}` : "";
  return {
    disabled: false,
    title: `Search indexing isn't complete on this slot${reasons}. Search on the live site would return partial results.`,
    describedById: searchIndexReasonsId(entry),
  };
}
